import { window } from '../../../globals';
import { useDialogContext } from '../../../contexts/DialogContext';
import { post } from '../../../redux/api';
import { getAuthorizeServiceURL } from '../../../helpers/services';

const GithubSettings = () => {
  const { onConfirm } = useDialogContext();

  return (
    <div>
      <div className="text-center margin-bottom-sm">
        <h1>Github Login</h1>
        <p>FOSSA allows users to link a Github login to their FOSSA login.</p>
      </div>
      <div className="card">
        {!window.user.github ? (
          <div className="service-connected-container">
            <h4>You are not connected to Github</h4>
            <a
              href={getAuthorizeServiceURL({
                vcsHost: 'github',
                location: window.location.href,
                serviceConnect: true,
              })}
              className="btn btn-service-connect">
              <span className="left fa-brands fa-github" />&nbsp;Connect to Github
            </a>
          </div>
        ) : (
          <div className="service-connected-container">
            <h4>
              You are currently connected{' '}
              {window.user.github.name ? (
                <span>
                  as <b>{window.user.github.name}</b>
                </span>
              ) : (
                <span>to GitHub</span>
              )}
            </h4>
            <button
              type="button"
              onClick={() => {
                onConfirm({
                  title: 'Confirm Github disconnect',
                  body: (
                    <div>
                      <p>
                        <b>Are you sure you want to disassociate the current user with the registered Github account?</b>{' '}
                        (cannot be undone)
                      </p>
                    </div>
                  ),
                  onConfirm: async () => {
                    await post('/api/services/github/disconnectService', undefined);
                    window.location.reload();
                  },
                });
              }}
              className="btn btn-primary btn-service-login-disconnect">
              Disconnect
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default GithubSettings;
